import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import NavigationMenu from '../components/NavigationMenu';
import Card from '../components/Card';
import { CalculatorIcon, FileTextIcon, FolderIcon, RefreshCwIcon, ChevronRightIcon } from 'lucide-react';
const Dashboard = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeCard, setActiveCard] = useState<number | null>(null);
  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };
  const shortcuts = [{
    title: 'Simulador Financiero',
    icon: <CalculatorIcon size={32} className="text-blue-600" data-id="element-91" />,
    path: '/simulator',
    description: 'Calcule opciones de pago y negociación'
  }, {
    title: 'Gestión de Acuerdos',
    icon: <FileTextIcon size={32} className="text-blue-600" data-id="element-92" />,
    path: '/agreements',
    description: 'Visualice y administre acuerdos activos'
  }, {
    title: 'Repositorio Documental',
    icon: <FolderIcon size={32} className="text-blue-600" data-id="element-93" />,
    path: '/repository',
    description: 'Acceda a documentos importantes'
  }];
  const handleCardClick = (path: string) => {
    navigate(path);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-94">
      <Header username="Carlos Pérez" onMenuClick={handleMenuToggle} notificationCount={3} data-id="element-95" />
      <NavigationMenu isOpen={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-96" />
      <main className="p-4 pb-20" data-id="element-97">
        {/* Pull to refresh indicator (just visual) */}
        <div className="flex justify-center mb-4 text-gray-400 text-sm" data-id="element-98">
          <RefreshCwIcon size={16} className="mr-2" data-id="element-99" />
          <span data-id="element-100">Desliza para actualizar</span>
        </div>
        {/* Summary Card */}
        <Card className="mb-6" data-id="element-101">
          <h2 className="text-lg font-semibold mb-3" data-id="element-102">Resumen</h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-103">
            <div className="bg-blue-50 p-3 rounded-lg" data-id="element-104">
              <div className="text-sm text-gray-600" data-id="element-105">Cuentas asignadas</div>
              <div className="text-xl font-bold text-blue-700" data-id="element-106">12</div>
            </div>
            <div className="bg-amber-50 p-3 rounded-lg" data-id="element-107">
              <div className="text-sm text-gray-600" data-id="element-108">Acuerdos pendientes</div>
              <div className="text-xl font-bold text-amber-700" data-id="element-109">5</div>
            </div>
          </div>
        </Card>
        {/* Quick Access Cards */}
        <h2 className="text-lg font-semibold mb-3" data-id="element-110">Accesos rápidos</h2>
        <div className="space-y-4" data-id="element-111">
          {shortcuts.map((item, index) => <div key={index} className={`
                relative overflow-hidden rounded-xl shadow-md 
                transform transition-all duration-200
                ${activeCard === index ? 'scale-[0.98] bg-blue-50' : 'hover:shadow-lg hover:scale-[1.01]'}
              `} onMouseDown={() => setActiveCard(index)} onMouseUp={() => setActiveCard(null)} onMouseLeave={() => setActiveCard(null)} onClick={() => handleCardClick(item.path)} data-id="element-112">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-50 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300" data-id="element-113"></div>
              <div className="flex items-center p-4 cursor-pointer bg-white relative z-10" data-id="element-114">
                <div className="mr-4 p-3 bg-blue-100 rounded-xl transition-colors" data-id="element-115">
                  {item.icon}
                </div>
                <div className="flex-1" data-id="element-116">
                  <h3 className="font-medium text-gray-900" data-id="element-117">{item.title}</h3>
                  <p className="text-sm text-gray-600" data-id="element-118">{item.description}</p>
                </div>
                <ChevronRightIcon size={20} className={`text-blue-600 transition-transform duration-200 ${activeCard === index ? 'translate-x-1' : ''}`} data-id="element-119" />
              </div>
              {/* Interactive highlight border */}
              <div className={`h-1 bg-blue-500 transition-all duration-300 ${activeCard === index ? 'w-full' : 'w-0'}`} data-id="element-120"></div>
            </div>)}
        </div>
      </main>
    </div>;
};
export default Dashboard;